var _clipPath;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgAlertBluei = function SvgAlertBluei(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1 .96)"
  }, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "alert-blue_i_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v25H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#alert-blue_i_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    fillRule: "nonzero",
    d: "M24 12.5c0 2.472-.704 4.889-2.022 6.945s-3.193 3.657-5.386 4.604-4.605 1.193-6.933.71-4.466-1.672-6.144-3.421-2.821-3.975-3.284-6.4S.005 10 .913 7.716s2.447-4.236 4.42-5.61S9.627 0 12 0c3.183 0 6.235 1.317 8.485 3.661S24 9.184 24 12.5m-2.568 0a10.1 10.1 0 0 0-1.59-5.455 9.52 9.52 0 0 0-4.231-3.616 9.1 9.1 0 0 0-5.447-.558 9.3 9.3 0 0 0-4.826 2.688 9.95 9.95 0 0 0-2.581 5.027 10.2 10.2 0 0 0 .536 5.674 9.75 9.75 0 0 0 3.47 4.407A9.16 9.16 0 0 0 12 22.324c2.501-.002 4.899-1.038 6.667-2.879s2.763-4.34 2.765-6.945m-7.719-5.378v5.163a1.82 1.82 0 0 1-.502 1.261c-.321.335-.757.523-1.211.523s-.89-.188-1.211-.523-.502-.789-.502-1.261V7.122c0-.473.181-.927.502-1.261s.757-.523 1.211-.523.89.188 1.211.523a1.82 1.82 0 0 1 .502 1.261m-.49 9.452a1.93 1.93 0 0 1 .49 1.265 2 2 0 0 1-.031.36 1.3 1.3 0 0 1-.1.323 1.5 1.5 0 0 1-.158.313l-.2.272c-.332.318-.767.495-1.218.495s-.886-.177-1.218-.495l-.207-.272a1.7 1.7 0 0 1-.158-.313 1.4 1.4 0 0 1-.1-.323l-.031-.36a1.8 1.8 0 0 1 .127-.683c.085-.217.211-.414.37-.58s.347-.297.555-.386.431-.134.656-.133c.456.007.892.193 1.223.519z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAlertBluei);
export default ForwardRef;